import script from "./bottleSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./bottleSuccess.vue?vue&type=script&setup=true&lang=js"

import "./bottleSuccess.vue?vue&type=style&index=0&id=4b9b36d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b9b36d4"]])

export default __exports__